import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/vercel/path0/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/product/[slug]/ProductLayout.tsx")